// extracted by mini-css-extract-plugin
module.exports = {"statusBox":"style_statusBox__QcoCC"};